var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M554 33.124L384 95.999L212 35.249C205.5 33.124 198.625 31.999 191.75 31.999C185.125 31.999 178.375 32.999 172 35.124L20.125 87.999C8 92.749 0 104.624 0 117.624V463.999C0 474.888 10.848 483.057 22 478.874L192 415.999L364 476.749C377 480.999 391 481.124 404 476.874L555.875 423.999C568 419.249 576 407.374 576 394.374V47.999C576 37.11 565.152 28.943 554 33.124ZM224 90.374L352 135.624V421.624L224 376.374V90.374ZM48 418V129.124L176 84.499V370.749L175.375 370.999L48 418ZM528 382.874L400 427.499V141.249L400.625 140.999L528 94V382.874Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.33881882493e848a0b162c042f186186.svg";
export { ForwardRef as ReactComponent };